import { useBusiness } from '@/contexts/BusinessContext';
import { Plug, CircleCheck as CheckCircle, Circle as XCircle } from 'lucide-react';

interface Props {
  onReconnect: () => void;
}

export default function IntegrationsSection({ onReconnect }: Props) {
  const { selectedBusiness } = useBusiness();
  const isConnected = !!selectedBusiness?.stripe_key_encrypted;

  return (
    <div>
      <h2 className="text-[11px] font-semibold text-white uppercase tracking-wider mb-2.5 px-1">Integrations</h2>
      <div className="glass-panel rounded-2xl p-2">
        <div className="flex items-center gap-3 py-2.5 px-3">
          <div className="w-9 h-9 rounded-xl bg-teal-500/10 flex items-center justify-center flex-shrink-0">
            <Plug size={15} className="text-teal-400" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-white">Stripe</p>
            <div className="flex items-center gap-1">
              {isConnected ? (
                <>
                  <CheckCircle size={11} className="text-green-700" />
                  <p className="text-[11px] text-green-800 font-medium">Connected</p>
                </>
              ) : (
                <>
                  <XCircle size={11} className="text-white" />
                  <p className="text-[11px] text-white">Not connected</p>
                </>
              )}
            </div>
          </div>
          <button
            onClick={onReconnect}
            className="px-3 py-1.5 text-xs font-semibold glass-inner border border-white/10 rounded-xl text-teal-400 glass-hover-teal"
          >
            {isConnected ? 'Re-connect' : 'Connect'}
          </button>
        </div>
      </div>
    </div>
  );
}
